var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { PermissionContext } from '@tribeplatform/gql-client/types';
import { FieldView } from '@tribeplatform/react-components/CustomField';
import { useMember, useNetwork, usePost, usePostType, } from '@tribeplatform/react-sdk/hooks';
export const FieldViewBlock = (_a) => {
    var { context, entityId, fieldKey, entityTypeId, preview } = _a, rest = __rest(_a, ["context", "entityId", "fieldKey", "entityTypeId", "preview"]);
    const { data: network } = useNetwork({
        fields: { memberFields: 'all' },
    });
    const { data: member } = useMember({
        variables: { id: entityId },
        fields: { fields: 'all' },
        useQueryOptions: {
            enabled: context === PermissionContext.MEMBER && !!entityId,
        },
    });
    const { data: post } = usePost({
        variables: { id: entityId },
        fields: { postType: { postFields: 'all' } },
        useQueryOptions: {
            enabled: context === PermissionContext.POST && !!entityId,
        },
    });
    const { data: postType } = usePostType({
        variables: { id: entityTypeId },
        fields: { postFields: 'all' },
        useQueryOptions: {
            enabled: context === PermissionContext.POST && !entityId && !!entityTypeId,
        },
    });
    const getFieldViewProps = () => {
        var _a, _b, _c, _d, _e;
        switch (context) {
            case PermissionContext.MEMBER:
                return {
                    entity: member,
                    field: (_b = (_a = network === null || network === void 0 ? void 0 : network.memberFields) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.find(field => field.key === fieldKey),
                };
            case PermissionContext.POST:
                return {
                    entity: post,
                    field: (_e = (_d = (_c = ((post === null || post === void 0 ? void 0 : post.postType) || postType)) === null || _c === void 0 ? void 0 : _c.postFields) === null || _d === void 0 ? void 0 : _d.fields) === null || _e === void 0 ? void 0 : _e.find(field => field.key === fieldKey),
                };
            default:
                return {};
        }
    };
    const { entity, field } = getFieldViewProps();
    if ((!preview && !entity) || !field) {
        return null;
    }
    return React.createElement(FieldView, Object.assign({ entity: entity, field: field, preview: preview }, rest));
};
//# sourceMappingURL=Block.js.map